'use client';

import { type PropsWithChildren } from 'react';
import { type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn/cn';
import { Button } from '../Button/Button';
import { notificationVariants } from './Notification.variants';

export type NotificationProps = PropsWithChildren &
  VariantProps<typeof notificationVariants> & {
    className?: string;
    onClose?: () => void;
    /** Function that is called when the user manually closes the notification. */
    onClickClose?: () => void;
    /** Accessible label for the close button (rendered when `onClose` is set). */
    closeButtonLabel?: string;
  };

export const Notification = ({
  children,
  severity = 'info',
  variant = 'default',
  onClose,
  onClickClose,
  closeButtonLabel,
  className,
}: NotificationProps) => (
  <div
    role={severity === 'error' || severity === 'warning' ? 'alert' : undefined}
    className={cn(notificationVariants({ variant, severity }), className)}
  >
    <span />
    <div className="notification-content">{children}</div>
    {onClose && (
      <Button
        onClick={() => {
          onClose?.();
          onClickClose?.();
        }}
        variant="icon-flat"
        className="h-4 w-4 rounded-sm"
        aria-label={closeButtonLabel}
      >
        <span className="icon-emp-cancel h-4 w-4" />
      </Button>
    )}
  </div>
);
